import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserTableService } from '../core/database/user-table.service';
import { BdEventsComponent } from './bd-events/bd-events.component';
import { SitePermissions } from 'src/app/shared/enums/permissions';
import { BdHomepageService } from './bd-homepage.service';
import { EmployerEventOptions } from 'src/app/shared/interfaces/employer-event';

@Component({
  selector: 'app-bd-homepage',
  templateUrl: './bd-homepage.component.html',
  styleUrls: ['./bd-homepage.component.scss'],
})
export class BdHomepageComponent implements OnInit {
  @ViewChild(BdEventsComponent) bdEventsComponent!: BdEventsComponent;

  constructor(
    private readonly userTableService: UserTableService,
    private readonly router: Router,
    private readonly bdHomepageService: BdHomepageService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  eventPermissions: { canEditEvent: boolean; canDeleteEvent: boolean } = {
    canEditEvent: false,
    canDeleteEvent: false,
  };

  staffId: number | null = null;
  loadingFilterOptions = false;
  filterError = false;

  filterOptions: EmployerEventOptions = {
    staff: [],
    hsTypes: [],
    types: [],
    branches: [],
  };

  selectedStaffOptions: any[] = [];
  selectedTypeOptions: any[] = [];

  private selectedStaffIds: number[] = [];
  private selectedTypeIds: number[] = [];
  availableTabs: string[] = [];
  activeTab = '';

  ngOnInit(): void {
    this.userTableService.get(1).then((user) => {
      if (!user || user == undefined || user == null) {
        this.router.navigate(['/']);
        return;
      }

      if (!user.permission.includes(SitePermissions.BdHomepageView)) {
        this.router.navigate(['/']);
        return;
      }

      this.eventPermissions.canEditEvent = user.permission.includes(SitePermissions.EmployerEventEdit);
      this.eventPermissions.canDeleteEvent = user.permission.includes(SitePermissions.EmployerEventDelete);

      this.staffId = user.staffId;
      const staffId = this.staffId;

      if (this.bdEventsComponent) {
        this.bdEventsComponent.setUp(staffId, this.eventPermissions);
        this.availableTabs = [...this.bdEventsComponent.tabs];
        this.activeTab = this.bdEventsComponent.activeTab;
      } else {
        Promise.resolve().then(() => {
          if (!this.bdEventsComponent) {
            return;
          }
          this.bdEventsComponent.setUp(staffId, this.eventPermissions);
          this.availableTabs = [...this.bdEventsComponent.tabs];
          this.activeTab = this.bdEventsComponent.activeTab;
        });
      }

      this.selectedStaffIds = [this.staffId];
      this.applyFilters(true);

      this.loadFilterOptions();
    });
  }

  onFilterChange(selection: any[], modelName: 'staff' | 'type'): void {
    if (this.filterError) {
      return;
    }

    const items = selection || [];
    const ids = items
      .map((item) => item?.id)
      .filter((id: number | undefined) => id !== undefined && id !== null) as number[];

    if (modelName === 'staff') {
      this.selectedStaffOptions = [...items];
      this.selectedStaffIds = ids.length ? ids : [];
    } else {
      this.selectedTypeOptions = [...items];
      this.selectedTypeIds = ids.length ? ids : [];
    }

    this.applyFilters();
  }

  clearFilters(): void {
    if (this.loadingFilterOptions || this.filterError) {
      return;
    }

    this.selectedStaffOptions = [];
    this.selectedStaffIds = [];
    this.selectedTypeOptions = [];
    this.selectedTypeIds = [];
    this.applyFilters(true);
  }

  selectTab(tab: string): void {
    if (!this.bdEventsComponent || this.activeTab === tab) {
      return;
    }

    this.bdEventsComponent.changeTab(tab);
  }

  onTabChanged(tab: string): void {
    this.activeTab = tab;
    if (!this.availableTabs.length && this.bdEventsComponent) {
      this.availableTabs = [...this.bdEventsComponent.tabs];
    }
  }

  private applyFilters(resetPage = true): void {
    if (!this.bdEventsComponent) {
      return;
    }

    const staffFilters = this.selectedStaffIds.length ? this.selectedStaffIds : [];
    const typeFilters = this.selectedTypeIds.length ? this.selectedTypeIds : [];

    this.bdEventsComponent.applyFilters(staffFilters, typeFilters, resetPage);
  }

  private loadFilterOptions(): void {
    if (this.staffId === null) {
      return;
    }

    this.loadingFilterOptions = true;
    this.filterError = false;

    this.bdHomepageService.getEventFilterOptions(this.staffId).subscribe({
      next: (options: EmployerEventOptions) => {
        this.filterOptions = options;
        this.setDefaultStaffSelection();
        this.selectedTypeOptions = [];
        this.selectedTypeIds = [];

        this.bdEventsComponent.setEventOptions(options);
        this.applyFilters(true);
      },
      error: (error) => {
        console.error(error);
        this.filterError = true;
        this.loadingFilterOptions = false;
        this.cdr.detectChanges();
      },
      complete: () => {
        this.loadingFilterOptions = false;
        this.cdr.detectChanges();
      },
    });
  }

  private setDefaultStaffSelection(): void {
    if (this.staffId === null) {
      this.selectedStaffOptions = [];
      this.selectedStaffIds = [];
      return;
    }

    const defaultStaff = (this.filterOptions?.staff || []).filter((staff) => staff.id === this.staffId);
    this.selectedStaffOptions = [...defaultStaff];
    this.selectedStaffIds = defaultStaff.length ? defaultStaff.map((staff) => staff.id) : [this.staffId];
  }
}
